// extracted by mini-css-extract-plugin
module.exports =  {"root":"OVPnNFgKWew9ESFVUlXC","vertical":"l8uJvRoyFi041Zi252V6","error":"I5G8Mb8qXakX2tLNMnXl","horizontal":"zhctrdHoQCpHe1SgzJyD"};